import FaqAiPage from 'components/AiPage/FaqAiPage'
import ContactInformation from 'components/HomePage/ContactInformation'
import { faqData } from 'constants/AiInRecruiting'
import AiInRecruitingBanner from './AiInRecruitingBanner'
import AiInRecruitingWhySection from './AiInRecruitingWhySection'
import AiInRecruitingTransformSection from './AiInRecruitingTransformSection'
import AiInRecruitingCapabilitiesSection from './AiInRecruitingCapabilitiesSection'
import AiInRecruitingCompareSection from './AiInRecruitingCompareSection'
import AiInRecruitingUseCasesSection from './AiInRecruitingUseCasesSection'
import AiSecurityIndustrySection from './AiInRecruitingIndustrySection'
import AiScoringImpactSectionData from './AiInRecruitingImpactSection'
import AiInRecruitingImplementationSection from './AiInRecruitingImplementationSection'
import AiInRecruitingIntegrationSection from './AiInRecruitingIntegrationSection'
import AiScoringChallengesSectionData from './AiInRecruitingChallengesSection'
import AiScoringWhyChooseSection from './AiInRecruitingWhyChooseSection'
import AiInRecruitingFutureSection from './AiInRecruitingFutureSection'
import AiInRecruitingCtaSection from './AiInRecruitingCtaSection'

const AiInRecruitingPage = () => {
  return (
    <>
      <AiInRecruitingBanner />
      <AiInRecruitingCapabilitiesSection />
      <AiInRecruitingTransformSection />
      <AiInRecruitingWhySection />
      <AiInRecruitingCompareSection />
      <AiInRecruitingUseCasesSection />
      <AiSecurityIndustrySection />
      <AiScoringImpactSectionData />
      <AiInRecruitingImplementationSection />
      <AiInRecruitingIntegrationSection />
      <AiScoringChallengesSectionData />
      <AiScoringWhyChooseSection />
      <AiInRecruitingFutureSection />
      <AiInRecruitingCtaSection />
      <FaqAiPage
        items={faqData}
        title="Frequently Asked"
        titleorange="Questions"
        subtitle={
          <>
            Still have questions? <br className="d-none d-xxl-block" />
            Let’s talk.
          </>
        }
      />
      <ContactInformation
        data={{
          title: 'Regional Contact Info',
          subTitle: 'We can give you the Wings to Fly. Contact us now!',
        }}
      />
    </>
  )
}

export default AiInRecruitingPage
